import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useId } from 'utils/hooks';
import { useRadio } from '../context';

export default function RadioOption({
  id = '',
  value = '',
  label = '',
  disabled = false,
  tooltipText = '',
  children = null
}) {
  const {
    name,
    value: selectedValue,
    onChange,
    disabled: isRootDisabled
  } = useRadio();

  const fallbackId = useId('radio');

  const inputId = id || fallbackId;
  const checked = selectedValue === value;
  const isDisabled = isRootDisabled || disabled;

  return (
    <li className={styles.container}>
      <input
        id={inputId}
        type="radio"
        name={name}
        checked={checked}
        onChange={event => onChange(value, event)}
        disabled={isDisabled}
        className={styles.input}
      />
      <UiKit.Label forceMount htmlFor={inputId} className={styles.marker}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <circle cx="8" cy="8" r="7.5" fill="white" className={styles.ring} />
          <circle cx="8" cy="8" r="4" className={styles.dot} />
        </svg>
      </UiKit.Label>
      <If test={label}>
        <div className={styles.content}>
          <UiKit.Label
            htmlFor={inputId}
            text={label}
            weight="normal"
            tooltipText={tooltipText}
            className={styles.label}
          />
          {children}
        </div>
      </If>
    </li>
  );
}
